'use strict';
angular.module('schoolLinqApp').factory('bankReconLogService', [
	'$http',
	function ($http) {
		var endpoint = '/api/bank-recon-log';

		function getByBankId(id) {
			return $http.get(endpoint + '/by-bank/' + id);
		}

		function add(reconSummary) {
			return $http.post(endpoint, reconSummary);
		}

		return {
			getByBankId: getByBankId,
			add: add,
		};
	},
]);
